import {
  Interface,
  useGenerateExecuteTemplate as useGenerateExecuteTemplateMutation,
  type GenerateExecuteTemplateState,
} from "@zapier/client";
import { useNotification } from "@zapier/utils";
import { useTranslations } from "@zapier/i18n";

interface Input {
  interfaceObject: Interface | undefined;
  setGenerateExecuteTemplateStatus: (
    status: GenerateExecuteTemplateState,
  ) => void;
  onClose: () => void;
  folderId?: string; // used for cache invalidation in mutations
}

export const useDuplicateInterface = ({
  interfaceObject,
  setGenerateExecuteTemplateStatus,
  onClose,
  folderId,
}: Input) => {
  const { createNotification } = useNotification();
  const t = useTranslations("interface-duplicate-modal");

  const { generateExecuteTemplate } = useGenerateExecuteTemplateMutation({
    id: interfaceObject?.id || "",
    setGenerateExecuteTemplateStatus,
    folderId,
  });

  // Main function to trigger duplication
  const duplicateInterface = async () => {
    if (!interfaceObject?.id) {
      createNotification({
        message: t("notifications.no-interface-selected"),
        type: "error",
      });
      return;
    }

    try {
      await generateExecuteTemplate();
    } catch (error) {
      console.error("Duplication failed:", error);
      onClose();
      createNotification({
        message: t("notifications.duplicate-error", {
          interfaceName: interfaceObject.name,
        }),
        type: "error",
      });
    }
  };

  return {
    duplicateInterface,
  };
};
